import { isSuccessResponse } from "../../../../common/utils";
import { useDispatch, useSelector } from "react-redux";
import useNotification from "../../../../components/notification/useNotification";
import { sendQuickAlerts } from "./sendQuickAlertsSlice";
import { useSpinner } from "../../../../customHooks";
import { IInitialSliceState } from "../../../../common/types/commonTypes";
import { actions as modalActions } from '../../../../components/modals/createAlert/createEditAlertModalSlice';
import { setEditQuickAlertData } from "../editQuickAlerts/editQuickAlertSlice";

interface ISendQuickAlertResponseState {
  sendQuickAlertsApi: IInitialSliceState;
}

export const useQuickAlertsRow = (item: any) => {
  const dispatch: any = useDispatch();
  const truncateMessage = (message: string) => {
    const maxLength = 30;
    return message.length > maxLength
      ? `${message.slice(0, maxLength)}...`
      : message;
  };

  const capitalizeSeverity = (severity: string) => {
    return severity.charAt(0).toUpperCase() + severity.slice(1);
  };
  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const dispatchSendQuickAlerts = (action, payload) => {
    try {
      dispatch(action(payload)).then((response) => {
        if (isSuccessResponse(response.payload)) {
          showSuccessNotification(response.payload.message);
        } else {
          showWarningNotification(response.payload.response.data.message);
        }
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSendAlert = (alertData) => {
    dispatchSendQuickAlerts(sendQuickAlerts, alertData);
  };
  const createQuickAlertsAlertResponse = useSelector(
    (state: ISendQuickAlertResponseState) => state.sendQuickAlertsApi
  );
  useSpinner(createQuickAlertsAlertResponse.status);

  const onEditQuickAlert = (): void => {
    dispatch(modalActions.turnOnEditQuickMode());
    dispatch(modalActions.showModal());
    dispatch(setEditQuickAlertData({ alertData: item }));
}

  return {
    onEditQuickAlert,
    handleSendAlert,
    truncateMessage,
    capitalizeSeverity,
  };
};
